
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import SchemaProfile from '@/components/schemas/SchemaProfile.vue';
import AllSchemas from '@/components/schemas/AllSchemas.vue';
import AddSchema from '@/components/schemas/AddSchema.vue';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';

import { SoftwareType, SchemaDic, SchemaData } from '@/store/models.def';

@Component({
	components: {
		SchemaProfile,
		AllSchemas,
		AddSchema,
	},
})
export default class SchemaManager extends Vue {
	public get groupedSchemas(): SchemaDic {
		return schemax.groupedSchemas;
	}
	public currentSchema: SchemaData | null = null;
}
